import React, { Component } from 'react';
import { Solution, Title, Wrapper } from 'components';
import styled from "react-emotion";
import backgroundImage from '../shared/images/banner_what-we-do.png';
import _ from 'lodash';

const StyledSolutions = styled.div`
    max-width: 100%;
`;

const SolutionsContainer = styled.div`
    background: url(${backgroundImage}) no-repeat;
    background-position: right bottom;
    padding-bottom: 10rem;
    background-size: 100%;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        background-size: 150%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        background-size: 200%;
    }
`;

const StyledSolutionGrid = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 1rem 0 2rem 0;
`;

class Solutions extends Component {
    render() {
        const { projectCategories } = this.props;
        const rows = _.sortBy(projectCategories, ['node.uid']).map((projectCategory) =>
            <Solution key={projectCategory.node.data.name} serviceName={projectCategory.node.data.name} color={projectCategory.node.data.category_colour} backgroundImage={projectCategory.node.data.category_image} categoryDescription={projectCategory.node.data.category_description.text} category_icon={projectCategory.node.data.category_icon} />
        );
        return (
            <StyledSolutions>
                <SolutionsContainer>
                    <Wrapper>
                        <div className='services-title'>
                            <h3 style={{ margin: 0 }}>What we do</h3>
                        </div>
                        <StyledSolutionGrid>
                            {rows}
                        </StyledSolutionGrid>
                    </Wrapper>
                </SolutionsContainer>
            </StyledSolutions>
        );
    }
}

export default Solutions;